import { memo, useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import * as ui from '@april9au/stack9-ui';

import { ApplicationDrawer } from './ApplicationDrawer/ApplicationDrawer';
import { BaseRequirementDrawer } from './BaseRequirementDrawer/BaseRequirementDrawer';
import { CountrySetupDrawer } from './CountrySetupDrawer/CountrySetupDrawer';
import { CountryTemplateDrawer } from './CountryTemplateDrawer/CountryTemplateDrawer';
import { OrganisationDrawer } from './OrganisationDrawer/OrganisationDrawer';
import { PartnerDrawer } from './PartnerDrawer/PartnerDrawer';

const Button = ui.S9Button.default;
const { Space } = ui;

const OrganisationActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = ui.useRefreshList();
  return (
    <>
      <OrganisationDrawer
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
      <Space>
        <Button label="Create" onClick={() => setIsOpen(true)} type="primary" />
      </Space>
    </>
  );
};

const PartnerActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = ui.useRefreshList();
  return (
    <>
      <PartnerDrawer
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
      <ui.Space>
        <Button label="Create" onClick={() => setIsOpen(true)} type="primary" />
      </ui.Space>
    </>
  );
};

const ApplicationActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = ui.useRefreshList();
  return (
    <>
      <ApplicationDrawer
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
      <ui.Space>
        <Button label="Create" onClick={() => setIsOpen(true)} type="primary" />
      </ui.Space>
    </>
  );
};

const BaseRequirementActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = ui.useRefreshList();
  return (
    <>
      <BaseRequirementDrawer
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
      <ui.Space>
        <Button label="Create" onClick={() => setIsOpen(true)} type="primary" />
      </ui.Space>
    </>
  );
};

const CountrySetupActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = ui.useRefreshList();
  return (
    <>
      <CountrySetupDrawer
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
      <ui.Space>
        <Button label="Create" onClick={() => setIsOpen(true)} type="primary" />
      </ui.Space>
    </>
  );
};

const CountryTemplateActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = ui.useRefreshList();
  return (
    <>
      <CountryTemplateDrawer
        initialValues={{ include_all_base_requirements: true }}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
      <ui.Space>
        <Button label="Create" onClick={() => setIsOpen(true)} type="primary" />
      </ui.Space>
    </>
  );
};

export const ActionBarComponent = memo(
  ({ defaultActions }: ui.ActionBarComponentProps) => (
    <>
      {defaultActions}
      <Routes>
        <Route path="organisation/list" element={<OrganisationActions />} />
        <Route path="partner/list" element={<PartnerActions />} />
        <Route path="application/list" element={<ApplicationActions />} />
        <Route
          path="base-requirement/list"
          element={<BaseRequirementActions />}
        />
        <Route path="country-setup/list" element={<CountrySetupActions />} />
        <Route
          path="country-template/list"
          element={<CountryTemplateActions />}
        />
      </Routes>
    </>
  ),
);
